import React, { useState } from "react";
import Modal from "react-modal";
import { IoMdClose } from "react-icons/io";
import { FiSave, FiArrowLeft } from "react-icons/fi";

import BackIcon from "../../assets/back-icon.png";

import styles from "./styles.module.css";
import Logo from "../../assets/logo-rh.png";
import { useContextSurveyQuiz } from "../../hooks/useSurveyQuiz";
import { useParams } from "react-router-dom";

interface IHeader {
  handleNavigate: () => void;
}

export const Header = ({ handleNavigate }: IHeader) => {
  const [modalOpen, setModalOpen] = useState(false);

  const {
    showSurveyQuiz,
    surveyQuizIndex,
    setShowSurveyQuiz,
    numTotalQuestions,
    setSurveyQuizIndex,
    numberTopics,
  } = useContextSurveyQuiz();

  const { hashID, surveyID, surveyTopicID } = useParams();

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      maxWidth: "420px",
      width: "calc(100% - 40px)",
      borderRadius: "20px",
      backgroundColor: "#fff",
      border: "none",
      padding: "0",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15), 0 4px 20px rgba(0, 0, 0, 0.08)",
      overflow: "hidden",
      animation: "slideUp 0.25s ease-out",
    },
  };

  const handleSave = () => {
    window.location.href = `/${hashID}`;
  };

  const handleBack = () => {
    if (surveyQuizIndex === 0) {
      numberTopics.forEach((topics, index) => {
        if (topics.idTopic === Number(surveyTopicID)) {
          if (index > 0) {
            window.location.href = `/${hashID}/survey-topic/${surveyID}/${
              numberTopics[index - 1].idTopic
            }`;
          } else {
            handleNavigate();
          }
        }
      });
    } else {
      setSurveyQuizIndex((old) => old - 1);
    }
  };

  return (
    <>
      <div className={styles.containerHeader}>
        <div
          className={styles.backArrow}
          onClick={() => {
            handleBack();
          }}
        >
          <img src={BackIcon} className={styles.backIcon} alt="back icon" />
        </div>
        <div>
          <img src={Logo} alt="logo-img" className={styles.logo} />
        </div>
        <div
          className={styles.closeButton}
          onClick={() => {
            if (showSurveyQuiz) {
              setModalOpen(true);
            } else {
              handleNavigate();
            }
          }}
        >
          <IoMdClose color="black" size={23} />
        </div>
      </div>
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        style={customStyles}
        contentLabel="Sair do questionário"
        overlayClassName={styles.overlay}
      >
        <div className={styles.containerModal}>
          <button
            className={styles.modalCloseBtn}
            onClick={() => setModalOpen(false)}
            aria-label="Fechar"
          >
            <IoMdClose size={20} />
          </button>

          <h1>Deseja sair do questionário?</h1>

          <p className={styles.modalSubtitle}>
            Não se preocupe, suas respostas anteriores já foram salvas automaticamente.
          </p>

          {numTotalQuestions > 0 && (
            <div className={styles.progressBadge}>
              <span className={styles.progressDot} />
              Questão {surveyQuizIndex + 1} de {numTotalQuestions}
            </div>
          )}

          <div className={styles.wrapperButton}>
            <button className={styles.btnPrimary} onClick={() => handleSave()}>
              <span className={styles.btnIcon}><FiSave /></span>
              Salvar e sair
            </button>
            <button className={styles.btnSecondary} onClick={() => setModalOpen(false)}>
              <span className={styles.btnIcon}><FiArrowLeft /></span>
              Continuar respondendo
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
